import { theme as antTheme, type ThemeConfig } from 'antd';

export const BRAND = { green: '#07843D', greenBright: '#17A95B', greenSoft: '#8FD2A9', siderDark: '#0B3B25', siderActive: '#07843D' } as const;

/** Ant Design tokens mapped from src/styles/tokens.css so both systems agree on brand, radius and type. */
export function buildTheme(mode: 'light' | 'dark'): ThemeConfig {
  const dark = mode === 'dark';
  return {
    algorithm: dark ? antTheme.darkAlgorithm : antTheme.defaultAlgorithm,
    token: {
      // Dark mode uses the brighter green: Ant derives tab/link/active colours from colorPrimary and the deep green fails 4.5:1 on dark cards.
      colorPrimary: dark ? BRAND.greenBright : BRAND.green,
      colorError: dark ? '#f87171' : '#b91c1c',
      colorLink: dark ? BRAND.greenSoft : BRAND.green,
      colorSuccess: BRAND.greenBright,
      colorInfo: BRAND.green,
      borderRadius: 6,
      fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif",
      fontSize: 14,
      controlHeight: 32,
      ...(dark ? { colorBgBase: '#0b0d14', colorBgContainer: '#0f111a', colorBgLayout: '#07080d', colorBorder: '#1a1d2e', colorText: '#EDF6F0', colorTextSecondary: '#A4AAA6' } : { colorBgLayout: '#f4f6f5' }),
    },
    components: {
      Layout: { siderBg: BRAND.siderDark, headerBg: dark ? '#0b0d14' : '#ffffff', headerHeight: 56, headerPadding: '0 16px', bodyBg: dark ? '#07080d' : '#f4f6f5' },
      Menu: { darkItemBg: BRAND.siderDark, darkSubMenuItemBg: BRAND.siderDark, darkItemSelectedBg: BRAND.siderActive, darkItemColor: '#DDE6E0', darkItemHoverBg: '#123D29', darkGroupTitleColor: '#7AC79B', itemHeight: 36, iconSize: 16 },
      Table: { headerBg: dark ? '#12151f' : '#f7f9f8', cellPaddingBlock: 10, cellPaddingInline: 12, rowHoverBg: dark ? '#12151f' : '#f2f7f4' },
      Tabs: { horizontalMargin: '0 0 12px 0' },
      Card: { paddingLG: 16 },
      Modal: { titleFontSize: 16 },
    },
  };
}
